const CONTENT_PAGE_LOADING = "CONTENT_PAGE_LOADING";
const CONTENT_PAGE_ERROR = "CONTENT_PAGE_ERROR";
const CONTENT_PAGE_SUCCESS = "CONTENT_PAGE_SUCCESS";


export {
    CONTENT_PAGE_LOADING,
    CONTENT_PAGE_ERROR,
    CONTENT_PAGE_SUCCESS,
};